<template>
  <v-card flat>
    <v-data-table hide-actions :items="items" :headers="headers" class="">
      <template slot="items" slot-scope="{ item }">
        <td>
          <v-checkbox
            hide-details
            color="primary"
            :label="item.title"
            @change="onIndexSelect(item.name)"
            v-model="permissions['all_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="primary"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['view_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="primary"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['add_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="primary"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['edit_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="primary"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['delete_' + item.name].value"
          />
        </td>
      </template>
      <template slot="footer">
        <td colspan="5">
          <div class="extra_permissions py-3">
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('view_accounts')"
              v-model="permissions.view_accounts.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('general_ledger')"
              v-model="permissions.ledger_report.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('lctr_report')"
              v-model="permissions.lctr_report.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('daily_profits')"
              v-model="permissions.daily_profit.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('incomes')"
              v-model="permissions.view_profits.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('cash_accounts')"
              v-model="permissions.view_cash_accounts.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('change_rate')"
              v-model="permissions.change_rate.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('view_all_branches_report')"
              v-model="permissions.view_all_branches_report.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('transactions_report')"
              v-model="permissions.transactions_report.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('view_dashboard')"
              v-model="permissions.view_dashboard.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('view_chart')"
              v-model="permissions.view_chart.value"
            />
            <v-checkbox
              hide-details
              color="primary"
              class="grid-item"
              :label="$t('delete_files')"
              v-model="permissions.delete_files.value"
            />
          </div>
        </td>
      </template>
    </v-data-table>
    <v-divider class="flex xs12" />
  </v-card>
</template>
<script>
export default {
  name: "permissions",
  props: {
    permissions: {
      default: () => [],
    },
  },
  computed: {
    headers: (vm) => [
      {
        text: vm.$t("part"),
        value: "title",
        sortable: false,
      },
      { text: vm.$t("view"), value: "s", sortable: false },
      { text: vm.$t("add"), value: "c", sortable: false },
      { text: vm.$t("edit"), value: "e", sortable: false },
      { text: vm.$t("delete"), value: "d", sortable: false },
    ],
    com_permissions() {
      if (this.permissions.all_customers) return this.permissions;
      return this.defaultPermissions;
    },

    items() {
      if (this.permissions.length < 1) {
        return [];
      } else {
        return [
          {
            title: this.$t("individuals"),
            name: "individuals",
          },
          {
            title: this.$t("corporates"),
            name: "corporates",
          },
          {
            title: this.$t("customers"),
            name: "customers",
          },
          {
            title: this.$t("branchs"),
            name: "branchs",
          },
          {
            title: this.$t("staffs"),
            name: "staffs",
          },
          {
            title: this.$t("sarafs"),
            name: "sarafs",
          },
          {
            title: this.$t("sarafs_commission"),
            name: "commissions",
          },
          {
            title: this.$t("shareholders"),
            name: "shareholders",
          },
          {
            title: this.$t("externals"),
            name: "externals",
          },
          {
            title: this.$t("banks"),
            name: "banks",
          },
          {
            title: this.$t("expenses"),
            name: "expenses",
          },
          {
            title: this.$t("incomes"),
            name: "incomes",
          },
          {
            title: this.$t("fixed_assets"),
            name: "assets",
          },
          {
            title: this.$t("liabilities"),
            name: "liabilities",
          },
          {
            title: this.$t("credits"),
            name: "credits",
          },
          {
            title: this.$t("debits"),
            name: "debits",
          },
          {
            title: this.$t("exchanges"),
            name: "exchanges",
          },
          {
            title: this.$t("send_transfers"),
            name: "send_transfers",
          },
          {
            title: this.$t("receive_transfers"),
            name: "receive_transfers",
          },
          {
            title: this.$t("a2a_transfers"),
            name: "a2a_transfers",
          },
          {
            title: this.$t("roles"),
            name: "roles",
          },
          {
            title: this.$t("users"),
            name: "users",
          },
          {
            title: this.$t("currencies"),
            name: "currencies",
          },
          {
            title: this.$t("backups"),
            name: "backups",
          },
        ];
      }
    },
  },
  methods: {
    onIndexSelect(name) {
      if (!this.permissions["all_" + name]["value"]) {
        this.permissions["add_" + name]["value"] = false;
        this.permissions["edit_" + name]["value"] = false;
        this.permissions["view_" + name]["value"] = false;
        this.permissions["delete_" + name]["value"] = false;
      } else {
        this.permissions["add_" + name]["value"] = true;
        this.permissions["edit_" + name]["value"] = true;
        this.permissions["view_" + name]["value"] = true;
        this.permissions["delete_" + name]["value"] = true;
      }
    },
  },
};
</script>
<style>
.extra_permissions {
  display: grid;
  grid-template-rows: 40px 40px auto;
  grid-template-columns: auto auto auto auto;
}
</style>